import { Link } from "react-router-dom";
import { AdminErrorMessage, EmptyState, StatusBadge } from "./AdminState";
import { useApi } from "./useApi";
import type { RequestStatus } from "../lib/constants";

type RequestRow = {
  id: string;
  request_no: string;
  created_at: string;
  organization_name: string;
  organization_type: string;
  city: string;
  property_type: string;
  request_purpose: string;
  status: RequestStatus;
  internal_owner: string | null;
  updated_at: string;
  next_action: string | null;
};

type Response = { requests: RequestRow[] };

export function AdminRequests() {
  const { data, error, status, loading } = useApi<Response>("/api/admin/requests");
  const requests = data?.requests ?? [];

  return (
    <section className="min-w-0 rounded-lg border border-line bg-white p-6 shadow-card">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow">إدارة الطلبات</p>
          <h1 className="text-3xl font-bold text-charcoal">الطلبات</h1>
        </div>
        <span className="status-badge status-badge-info">Cloudflare Access</span>
      </div>
      {loading ? <p>جاري التحميل...</p> : null}
      {error ? <AdminErrorMessage error={error} status={status} /> : null}
      {data ? (
        requests.length ? (
          <div className="max-w-full overflow-x-auto">
          <table className="w-full min-w-[1100px] text-right text-sm">
            <thead className="bg-sand text-charcoal">
              <tr>
                {[
                  "رقم الطلب",
                  "تاريخ الإنشاء",
                  "الجهة",
                  "نوع الجهة",
                  "المدينة",
                  "نوع العقار",
                  "الغرض",
                  "الحالة",
                  "المسؤول",
                  "آخر تحديث",
                  "الإجراء التالي",
                ].map((heading) => (
                  <th key={heading} className="px-3 py-3 font-bold">
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {requests.map((request) => (
                <tr key={request.id} className="border-b border-line">
                  <td className="px-3 py-3 font-bold text-charcoal">
                    <Link to={`/admin/requests/${request.id}`}>{request.request_no}</Link>
                  </td>
                  <td className="px-3 py-3">{request.created_at}</td>
                  <td className="px-3 py-3">{request.organization_name}</td>
                  <td className="px-3 py-3">{request.organization_type}</td>
                  <td className="px-3 py-3">{request.city}</td>
                  <td className="px-3 py-3">{request.property_type}</td>
                  <td className="px-3 py-3">{request.request_purpose}</td>
                  <td className="px-3 py-3">
                    <StatusBadge status={request.status} />
                  </td>
                  <td className="px-3 py-3">{request.internal_owner ?? "-"}</td>
                  <td className="px-3 py-3">{request.updated_at}</td>
                  <td className="px-3 py-3">{request.next_action ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        ) : (
          <EmptyState>لا توجد طلبات مسجلة حالياً.</EmptyState>
        )
      ) : null}
    </section>
  );
}
